import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import Input from '../Input/Input';
import { Size } from '../../Constants/System';
import copyToClipboard from 'copy-to-clipboard';
import Tooltip from '../../Components/Interactive/Tooltip/Tooltip';
import { mergeWithDefaults } from '../../Utility/PropUtils';
import useInputValue from '../../Hooks/UseInputValue';
import { InputInlineActions, InputInlineIcon } from '../Input/InputStyles';
import SecureRandomString from '@cb/common-ts/SecureRandomString';
const DefaultPasswordInputProps = {
    isShowPasswordVisible: true,
    isGeneratePasswordVisible: false,
    isCopyPasswordVisible: false,
    className: '',
    label: 'Password',
};
function PasswordInput(providedProps) {
    const props = mergeWithDefaults(providedProps, DefaultPasswordInputProps);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [value, setValue] = useInputValue(props, '');
    const copyPasswordToClipboard = (val) => {
        const isCopySuccessful = copyToClipboard(val ?? value ?? '');
        if (props.onCopyToClipboard) {
            props.onCopyToClipboard(isCopySuccessful);
        }
    };
    const handleChange = (val) => {
        setValue(val);
        props.onChange?.(val);
    };
    const generatePassword = () => {
        const password = SecureRandomString.generateAlphanumeric(12);
        props.validation?.validate(password);
        copyPasswordToClipboard(password);
        setIsPasswordVisible(true);
        handleChange(password);
    };
    const size = props.size ?? Size.medium;
    let inlineActionsView;
    let postActionsView;
    const passwordVisibleIcon = isPasswordVisible ? 'look-off' : 'look';
    if (props.isShowPasswordVisible || props.isCopyPasswordVisible) {
        inlineActionsView = (_jsxs(InputInlineActions, { "$size": size, disabled: props.disabled, "$hidePointerEvents": props.disabled, children: [props.isShowPasswordVisible ? (_jsx(Tooltip, { text: `${isPasswordVisible ? 'Hide' : 'Show'} password`, placement: "top", duration: [0, 0], children: _jsx(InputInlineIcon, { name: passwordVisibleIcon, onClick: () => setIsPasswordVisible(!isPasswordVisible) }) })) : null, props.isCopyPasswordVisible ? (_jsx(Tooltip, { text: "Copy password", placement: "top", duration: [0, 0], children: _jsx(InputInlineIcon, { name: "file-copy", onClick: () => copyPasswordToClipboard() }) })) : null] }));
    }
    if (props.isGeneratePasswordVisible && !props.disabled) {
        postActionsView = (_jsx(PostActions, { size: size, children: _jsx("a", { href: "#", onClick: (e) => {
                    e.preventDefault();
                    generatePassword();
                }, children: "Generate a secure password for me" }) }));
    }
    return (_jsxs(Input, { ...props, type: isPasswordVisible ? 'text' : 'password', onChange: handleChange, value: value, size: size, children: [inlineActionsView, postActionsView] }));
}
export default PasswordInput;
const PostActions = styled.div `
	text-align: right;
	margin-top: ${(props) => props.theme.spacing.xxs};
	font-size: ${(props) => props.theme.typography.sm};
`;
//# sourceMappingURL=PasswordInput.js.map